__turbopack_context__.v({
  "root": "PlasmicCsLinkButton-module__KPXl6a__root",
  "rootpurple_basicPurple": "PlasmicCsLinkButton-module__KPXl6a__rootpurple_basicPurple",
  "rootpurple_purpleHover": "PlasmicCsLinkButton-module__KPXl6a__rootpurple_purpleHover",
});
